<template>
    <div>

        <div class="modal fade" id="planningServiceEventBoxModal" tabindex="-1" aria-labelledby="planningServiceEventBoxModal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="px-4 py-2">
                        <div class="modal-icon text-center mt-2">
                            <span class="round-icon bg-lightyellow">
                                <i class="fa fa-bell text-primary" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="modal-body">
                            <h3 class="mb-2 text-primary text-center">Gegevens planning</h3>
                            <table style="width: 100%;">
                                <tr>
                                    <td style="width: 35%;" class="strong">Naam</td>
                                    <td style="width: 65%;" class="strong">{{ this.item.title }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Montage periode</td>
                                    <td>{{ this.item.start_date }} - {{ this.item.end_date }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Datum</td>
                                    <td>{{ this.item.date }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Tijd</td>
                                    <td>{{ this.item.start_time }} - {{ this.item.end_time }}</td>
                                </tr>
                            </table>
                            <div class="container_note">
                                <span class="strong">Opmerking</span>
                                <p>
                                    <span v-if="this.item.note">
                                        {{ this.item.note }}
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </p>
                            </div>
                            <div v-if="this.item.planning_service_url" class="modal-body pt-4 px-4 pb-4 d-flex">
                                <a :href="this.item.planning_service_url" class="btn btn-primary ms-auto px-3 py-2 text-sm">
                                    Bekijk opdracht
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {EventBus} from "../../../event-bus";

    export default {
        name: 'planning-service-modal',
        components: {},
        props: {},
        data() {
            return {
                item: {
                    type: null,
                    team_id: null,
                    type_id: null,
                    date: null,
                    start_time: null,
                    end_time: null,
                    start_date: null,
                    end_date: null,
                    order_url: null,
                    note: null,
                }
            }
        },
        computed: {},
        watch: {},
        methods: {},
        mounted() {

            this.planningServiceEventBoxModal = new bootstrap.Modal(document.getElementById('planningServiceEventBoxModal'));

            EventBus.$on('showPlanningServiceEvent', (item) => {
                this.item = item;
                this.planningServiceEventBoxModal.show();
            });
        },
        created() {},
    }
</script>

<style scoped>
    td {
        vertical-align: top;
    }
    .fc-event{
        cursor: pointer;
    }

    div.container_note {
        overflow-wrap: break-word;
    }

    div.container_note span {
        font-size: 14px;
        padding: .5rem .5rem .5rem 0;
    }

    div.container_note p {
        margin-top: 0.5rem;
        background-color: #f5f5f5;
        padding:10px;
    }
</style>
